/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const AppSpecificUninstallableReasonTypename = 'com.hubspot.marketplace.installs.models.compatibility.AppSpecificUninstallableReason';
export const AppSpecificUninstallableReasonV2Typename = 'com.hubspot.marketplace.installs.models.compatibility.AppSpecificUninstallableReasonV2';
export const getInstallCountRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallCount',
  auth: 'internal',
  fingerprint: '1GVyj-c0nbbLhlmz-StH-2abcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstallCountBatchRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallCountBatch',
  auth: 'internal',
  fingerprint: 'DNd7wgjU8CH7NryORdFGcmabcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const sendInstallIntentRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'sendInstallIntent',
  auth: 'internal',
  fingerprint: 'kRfYehF9JMeOUe2e_r4XmZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstallCompatibilityRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallCompatibility',
  auth: 'internal',
  fingerprint: 'EMEKYpDHguAT-ezggfE8rGabcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstallabilityRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallability',
  auth: 'internal',
  fingerprint: '2g_WAhcPm2bCRLOQHE-AbWabcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOAuthUrlRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getOAuthUrl',
  auth: 'internal',
  fingerprint: 'JZt2TrxwxYT5LYzHdF922mabcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInstallExemptionStatusRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getInstallExemptionStatus',
  auth: 'internal',
  fingerprint: 'eK15BktC1bQB-PCeIJe2pZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRequiredScopeGroupsRpc = {
  serviceName: 'com.hubspot.marketplace.installs.rpc.MarketplaceInstallsRpc',
  rpcName: 'getRequiredScopeGroups',
  auth: 'internal',
  fingerprint: '1fUg7LvEQIRiVJsVpGvLTGabcsFx5_XF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};